"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBase = void 0;
var _core = require("@dragon/core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ButtonBase = exports.ButtonBase = /*#__PURE__*/function () {
  function ButtonBase(id, action, clickSound) {
    _classCallCheck(this, ButtonBase);
    _defineProperty(this, "_id", void 0);
    _defineProperty(this, "action", void 0);
    _defineProperty(this, "_throttle", void 0);
    _defineProperty(this, "clickSound", void 0);
    this._id = id;
    this.action = action;
    this.clickSound = clickSound;
  }
  return _createClass(ButtonBase, [{
    key: "onClick",
    value: function onClick() {
      var _this = this;
      if (this._throttle) return;
      this._throttle = true;
      if (this.clickSound) _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, "uiclick"));
      if (!this.action) _core.CORE.dispatch({
        type: this._id
      });else _core.CORE.dispatch(this.action);
      setTimeout(function () {
        _this._throttle = false;
      }, 50);
    }
  }]);
}();
//# sourceMappingURL=ButtonBase.js.map